import type { TOC } from '@ember/component/template-only';
import ModalInviteUsers from 'lumen/components/settings/users/modals/modal-invite-users';
import UsersTable from 'lumen/components/settings/users/tables/users-table';
import type HotelSettingsUsersController from 'lumen/controllers/hotel/settings/users';

interface HotelSettingsUsersSignature {
  Args: {
    controller: HotelSettingsUsersController;
  };
}

const HotelSettingsUsers: TOC<HotelSettingsUsersSignature> = <template>
  <UsersTable
    @aggregatedUserCount={{@controller.totalRecords}}
    @aggregatedUsers={{@controller.accumulatedAggregatedUsers}}
    @appliedSearch={{@controller.search}}
    @displaySearchValue={{@controller.displaySearchValue}}
    @isAdmin={{@controller.isAdmin}}
    @isAllSubscriptions={{@controller.isAllSubscriptions}}
    @isLoading={{@controller.isLoading}}
    @onBulkApply={{@controller.applyBulkChanges}}
    @onDeleteUser={{@controller.deleteUser}}
    @onInvite={{@controller.openInviteModal}}
    @onLoadMore={{@controller.loadMoreTask.perform}}
    @onProductChange={{@controller.updateProduct}}
    @onRoleChange={{@controller.updateRole}}
    @onSave={{@controller.saveChanges}}
    @onSearchChange={{@controller.updateSearch}}
    @onSortChange={{@controller.onUpdateSorts}}
    @onSubscriptionChange={{@controller.updateSubscription}}
    @product={{@controller.product}}
    @role={{@controller.role}}
    @selectedSubscription={{@controller.selectedSubscription}}
    @sorts={{@controller.sorts}}
    @totalUserCount={{@controller.totalRecords}}
    @users={{@controller.accumulatedUsers}}
  />

  {{#if @controller.isInviteModalVisible}}
    <ModalInviteUsers @onClose={{@controller.closeInviteModal}} />
  {{/if}}

  {{outlet}}
</template>;

export default HotelSettingsUsers;
